const province = [
  "กรุงเทพฯ",
  "กระบี่",
  "กาญจนบุรี",
  "กาฬสินธุ์",
  "กำแพงเพชร",
  "ขอนแก่น",
  "จันทบุรี",
  "ฉะเชิงเทรา",
  "ชลบุรี",
  "ชัยนาท",
  "ชัยภูมิ",
  "ชุมพร",
  "เชียงใหม่",
  "เชียงราย",
  "ตรัง",
  "ตราด",
  "ตาก",
  "นครนายก",
  "นครปฐม",
  "นครพนม",
  "นครราชสีมา",
  "นครศรีธรรมราช",
  "นครสวรรค์",
  "นนทบุรี",
  "นราธิวาส",
  "น่าน",
  "บึงกาฬ",
  "บุรีรัมย์",
  "ปทุมธานี",
  "ประจวบคีรีขันธ์",
  "ปราจีนบุรี",
  "ปัตตานี",
  "พระนครศรีอยุธยา",
  "พะเยา",
  "พังงา",
  "พัทลุง",
  "พิจิตร",
  "พิษณุโลก",
  "เพชรบุรี",
  "เพชรบูรณ์",
  "แพร่",
  "ภูเก็ต",
  "มหาสารคาม",
  "มุกดาหาร",
  "แม่ฮ่องสอน",
  "ยโสธร",
  "ยะลา",
  "ร้อยเอ็ด",
  "ระนอง",
  "ระยอง",
  "ราชบุรี",
  "ลพบุรี",
  "ลำปาง",
  "ลำพูน",
  "เลย",
  "ศรีสะเกษ",
  "สกลนคร",
  "สงขลา",
  "สตูล",
  "สมุทรปราการ",
  "สมุทรสงคราม",
  "สมุทรสาคร",
  "สระแก้ว",
  "สระบุรี",
  "สิงห์บุรี",
  "สุโขทัย",
  "สุพรรณบุรี",
  "สุราษฎร์ธานี",
  "สุรินทร์",
  "หนองคาย",
  "หนองบัวลำภู",
  "อ่างทอง",
  "อำนาจเจริญ",
  "อุดรธานี",
  "อุตรดิตถ์",
  "อุทัยธานี",
  "อุบลราชธานี",
];

export const province_th = [
  { name: "กรุงเทพฯ" },
  { name: "กระบี่" },
  { name: "กาญจนบุรี" },
  { name: "กาฬสินธุ์" },
  { name: "กำแพงเพชร" },
  { name: "ขอนแก่น" },
  { name: "จันทบุรี" },
  { name: "ฉะเชิงเทรา" },
  { name: "ชลบุรี" },
  { name: "ชัยนาท" },
  { name: "ชัยภูมิ" },
  { name: "ชุมพร" },
  { name: "เชียงใหม่" },
  { name: "เชียงราย" },
  { name: "ตรัง" },
  { name: "ตราด" },
  { name: "ตาก" },
  { name: "นครนายก" },
  { name: "นครปฐม" },
  { name: "นครพนม" },
  { name: "นครราชสีมา" },
  { name: "นครศรีธรรมราช" },
  { name: "นครสวรรค์" },
  { name: "นนทบุรี" },
  { name: "นราธิวาส" },
  { name: "น่าน" },
  { name: "บึงกาฬ" },
  { name: "บุรีรัมย์" },
  { name: "ปทุมธานี" },
  { name: "ประจวบคีรีขันธ์" },
  { name: "ปราจีนบุรี" },
  { name: "ปัตตานี" },
  { name: "พระนครศรีอยุธยา" },
  { name: "พะเยา" },
  { name: "พังงา" },
  { name: "พัทลุง" },
  { name: "พิจิตร" },
  { name: "พิษณุโลก" },
  { name: "เพชรบุรี" },
  { name: "เพชรบูรณ์" },
  { name: "แพร่" },
  { name: "ภูเก็ต" },
  { name: "มหาสารคาม" },
  { name: "มุกดาหาร" },
  { name: "แม่ฮ่องสอน" },
  { name: "ยโสธร" },
  { name: "ยะลา" },
  { name: "ร้อยเอ็ด" },
  { name: "ระนอง" },
  { name: "ระยอง" },
  { name: "ราชบุรี" },
  { name: "ลพบุรี" },
  { name: "ลำปาง" },
  { name: "ลำพูน" },
  { name: "เลย" },
  { name: "ศรีสะเกษ" },
  { name: "สกลนคร" },
  { name: "สงขลา" },
  { name: "สตูล" },
  { name: "สมุทรปราการ" },
  { name: "สมุทรสงคราม" },
  { name: "สมุทรสาคร" },
  { name: "สระแก้ว" },
  { name: "สระบุรี" },
  { name: "สิงห์บุรี" },
  { name: "สุโขทัย" },
  { name: "สุพรรณบุรี" },
  { name: "สุราษฎร์ธานี" },
  { name: "สุรินทร์" },
  { name: "หนองคาย" },
  { name: "หนองบัวลำภู" },
  { name: "อ่างทอง" },
  { name: "อำนาจเจริญ" },
  { name: "อุดรธานี" },
  { name: "อุตรดิตถ์" },
  { name: "อุทัยธานี" },
  { name: "อุบลราชธานี" },
];
